import { Box, Divider, Text } from "@chakra-ui/layout";
import { Spinner } from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { GlobalTable } from "../../withdrawal/components/global-table-template";
import { getEnergySubscription } from "../service";
import { LightSubscriptionTableBody } from "./table-data/TableBody";
import { LightSubscriptionTableHead } from "./table-data/TableHead";

export const LightSubscription = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    const loadData = async () => {
      const result = await getEnergySubscription(setLoading);
      setData(result);
    };
    loadData();
  }, []);

  return (
    <Box m="10px 0" p="20px" bg="#fff" boxShadow="md" borderRadius="5px">
      <Text color="#8366A5" marginBottom="10px">
        <b>Energy Subscription</b>
      </Text>
      <Divider />
      <Box h="300px" overflow="auto" position="relative">
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            <Spinner size="xl" color="purple.500" />
          </Box>
        ) : (
          <GlobalTable
            tableHead={<LightSubscriptionTableHead />}
            tableBody={<LightSubscriptionTableBody Data={data} />}
            striped={false}
          />
        )}
      </Box>
    </Box>
  );
};
